import { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { FaChevronDown } from 'react-icons/fa';
import { UserContext } from '../../context/user-context'
import { formatDate, formatCurrency } from '../../utils/utilities';

import './sales.css'

export default function Sales() {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { userToken, user } = useContext(UserContext);
  const [visibleIndexes, setVisibleIndexes] = useState([]);
  const [continueScrolling, setContinueScrolling] = useState(true)

  useEffect(() => {
    // fetchOrders(page);
    fetchUserSales();
  }, [page]);

  /*
  const fetchOrders = async (page) => {
    try {
      if (!continueScrolling) {
        return
      }
      const res = await axios.get(`${process.env.REACT_APP_WC_API_URL}/orders`, {
        auth: {
          username: process.env.REACT_APP_WC_CONSUMER_KEY,
          password: process.env.REACT_APP_WC_CONSUMER_SECRET,
        },
        headers: {
          'Authorization': 'Basic ' + btoa(user?.user_login + ":" + userToken),
          'Content-Type': 'multipart/form-data'
        },
        params: {
          per_page: 50,
          page: page
        }
      });
      if (res.data){
        console.log((res.data && res.data.length >= 50))
        setContinueScrolling((res.data && res.data.length >= 50))
        setOrders((prevItems) => [...prevItems, ...res.data]);
        setLoading(false);
      }
    } catch (error) {
      // setError('Failed to fetch orders');
      console.error(error);
      setLoading(false);
    }
  };
  */

  const fetchUserSales = async () => {
    try {
      setLoading(true);
      const time = new Date().getTime();
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/wp-json/gnetwork/v1/users/${user?.ID}/customer-orders?timestamp=${time}`,
        {
          headers: {
            'Authorization': 'Basic ' + btoa(user?.user_login + ":" + userToken),
            'Content-Type': 'multipart/form-data'
          },
        }
      );
      if (res.data) {
        console.log(res.data)
        setOrders(res.data.orders);
        setLoading(false);
      }
    } catch (error) {
      // setError('Failed to fetch orders');
      console.error(error);
      setLoading(false);
    }
  }

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.innerHeight + document.documentElement.scrollTop >=
  //       document.documentElement.offsetHeight - 100
  //     ) {
  //       if (!loading && continueScrolling) {
  //         setPage((prevPage) => prevPage + 1);
  //       }
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [loading, continueScrolling]);

  const filteredOrders = orders.filter(function(order) {
    return (
      order.billing_first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.billing_last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.billing_city.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.billing_email.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const toggleInfoArea = (index) => {
    setVisibleIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <Container>
      <Row className="mb-3">
        <Col md="auto">
          <h1 className="m-0">My Sales</h1>
          <p>My customer asset orders.</p>
          <p className="text-danger">THIS DATA IS NOT ACCURATE, what you actually need to do, is get all the downlines of the affiliate then compile alll the orders of those downlines</p>
        </Col>
        <Col className="text-center">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Filter orders"
            className="sales-search"
          />
        </Col>
      </Row>
      {(loading) && (
        <Row>
          <Col>
            <p>Loading...</p>
          </Col>
        </Row>
      )}
      {(!loading && orders.length == 0) && (
        <Row className="text-center">
          <Col>
            <h4>No customer orders yet.</h4>
          </Col>
        </Row>
      )}
      {!loading && (filteredOrders.length > 0) && (
        <Card className="mb-3" style={{ width: '100%' }}>
          <Card.Body>
            <div className="event-items">
              {filteredOrders.map((order, index) => (
                <div key={index}>
                  <Row className={`event-item align-items-center ${loading ? 'loading-skeleton' : ''}`} >
                    <Col className="event-item_details">
                      <h4 className="m-0">{order.billing_first_name} {order.billing_last_name}</h4>
                    </Col>
                    <Col className="event-item_details">
                      <h5 className="m-0">{formatDate(order.date_created)}</h5>
                    </Col>
                    <Col className="event-item_details">
                      <h5 className="m-0">{formatCurrency(order.total)}</h5>
                    </Col>
                    <Col className="event-item_actions">
                      <Button onClick={() => toggleInfoArea(index)} variant="secondary">
                        <FaChevronDown style={{
                          transform: `rotate(${visibleIndexes.includes(index) ? 180 : 0}deg)`,
                          transition: "transform 0.3s ease-in-out",
                        }}/>
                      </Button>
                    </Col>
                  </Row>
                  <Row 
                    id="sales-slide-content" 
                    className={`sales-slide-content${index} sales-slide-content ${visibleIndexes.includes(index) ? "visible" : ""}`}
                  >
                    <Container>
                    <Row className="d-flex flex-row">
                      <Col className="p-3 event-item">
                        <span>Ticket type:</span>
                        {order?.line_items && (
                          <h5>{Object.values(order.line_items)[0]?.name || 'N/A'}</h5>
                        )}
                      </Col>
                      <Col className="p-3 event-item">
                        <span>Customer Details:</span>
                        <p className="m-0">{order.billing_city}</p>
                        <p className="m-0">{order.billing_email}</p>
                        <p className="m-0">{order.billing_phone}</p>
                      </Col>
                    </Row>
                    </Container>
                  </Row>
                </div>
              ))}
              {continueScrolling && (
                <Row className="text-center">
                  <Col>
                    <Button 
                      onClick={() => {
                        setPage((prevPage) => prevPage + 1)
                      }}
                      variant="secondary"
                    >Load More</Button>
                  </Col>
                </Row>
              )}
            </div>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
}
